import React, { useRef, useState, useEffect } from "react";

import { Scrollbox } from "@packages/ds";
import { useIntl } from "react-intl";

import * as Table from "ds/Table";

import { EnvironmentTreeData } from "../utils";

import * as S from "./List.styles";
export type Filter = "title" | "type" | "created_at" | "deployed_at";

type ListProps = {
  environments: EnvironmentTreeData[];
  sort: {
    type: "title" | "type" | "created_at" | "deployed_at";
    order: "asc" | "desc";
  };
  titleFilter: string;
  toggleSort: (
    e: React.MouseEvent | undefined,
    value: "title" | "type" | "created_at" | "deployed_at"
  ) => void;
};
const RESIZE_LIST_WIDTH = 716;

const List = ({
  environments = [],
  sort,
  titleFilter,
  toggleSort
}: ListProps) => {
  const intl = useIntl();
  const [isBigScreen, setIsBigScreen] = useState(false);
  const targetRef = useRef<HTMLDivElement>(null);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const checkIsBigScreen = e => {
    return e.offsetWidth > RESIZE_LIST_WIDTH;
  };

  useEffect(() => {
    if (checkIsBigScreen(targetRef.current)) {
      setIsBigScreen(true);
    } else {
      setIsBigScreen(false);
    }
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [windowWidth]);

  const filters: Filter[] = isBigScreen
    ? ["title", "type", "created_at", "deployed_at"]
    : ["title", "deployed_at"];

  return (
    <S.Wrapper ref={targetRef}>
      <Table.Table>
        <S.TableThead>
          {filters.map(elt => (
            <S.TableTh
              key={`sort-${elt}`}
              kind={elt}
              onSortChanged={() => {
                toggleSort(undefined, elt);
              }}
              isSortActive={sort.type === elt}
              sortDirection={sort.order}
            >
              <S.EnvLabel>
                {intl.formatMessage({
                  id: `environmentTree.sort.${elt}`
                })}
              </S.EnvLabel>
            </S.TableTh>
          ))}
          <Table.Th>
            <S.EnvLabel>
              {intl.formatMessage({ id: "environmentTree.sort.url" })}
            </S.EnvLabel>
          </Table.Th>
        </S.TableThead>
      </Table.Table>

      <Scrollbox
        {...(environments.length > 12 && {
          style: { height: "706px" }
        })}
        onScroll={() => document.dispatchEvent(new Event("scrolled"))}
      >
        {environments.map(node => (
          <S.EnvironmentListBar
            key={`env-${node.title}`}
            displayMode="list"
            node={node}
            titleFilter={titleFilter}
            isBigScreen={isBigScreen}
          />
        ))}
      </Scrollbox>
    </S.Wrapper>
  );
};

export default List;
